import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const transitionDriverFactory = base => {
  const { element, exists } = baseUniDriverFactory(base);
  return {
    exists,
    element,
  };
};
